import { cn } from '@plato/ui/util/classes';

type Props = {
    logoColor?: LogoColour;
    className?: string;
};

type LogoColour = 'blue' | 'black' | 'white';

const colorMap: Record<LogoColour, string> = {
    blue: '#155EEF',
    black: 'black',
    white: 'white',
};

export function PlatoLogo({ className = '', logoColor = 'blue' }: Props) {
    const fill = colorMap[logoColor];

    return (
        <svg
            className={cn('h-7 w-auto', className)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                d="M17.3819 3.54561L14.0881 0.32373L0.566247 13.5504L3.86004 16.7723L17.3819 3.54561Z"
                fill={fill}
            />
            <path
                d="M22.928 18.8074L14.6068 10.6679L6.11233 18.9769L14.4335 27.1164L22.928 18.8074Z"
                fill={fill}
            />
            <path
                d="M27.9579 13.8893L19.6367 5.74982L16.6896 8.63255L25.0108 16.772L27.9579 13.8893Z"
                fill={fill}
            />
        </svg>
    );
}
